// TODO: here is the example of all locales
// eslint-disable-next-line max-len
//https://stackoverflow.com/questions/2388115/get-locale-short-date-format-using-javascript#:~:text=const%20formats%20%3D%20%7B%0A%20%20%20%20%22af,yyyy/MM/dd%22%2C%0A%20%20%7D%3B

const thousand = 1000;
const ten = 10;
export type TFormatterType =
  | 'dd/mm/yyyy hh:mm:ss'
  | 'dd/mm/yyyy hh:mm'
  | 'dd/mm/yyyy; hh:mm:ss'
  | 'dd.mm.yyyy'
  | 'Mm dd, yyyy hh:mm:ss'
  | 'Mm dd, yyyy';

export const dateFormats = (
  date: number | Date,
  formatterType: TFormatterType
) => {
  switch (formatterType) {
    case 'dd/mm/yyyy hh:mm':
      return `${getDateEN(getFullyDate(date))} ${getTimeGBSecondsFree(
        getFullyDate(date)
      )}`;
    case 'dd/mm/yyyy; hh:mm:ss':
      return `${getDateEN(getFullyDate(date))}; ${getTimeGB(
        getFullyDate(date)
      )}`;
    case 'dd.mm.yyyy':
      return getDateBY(getFullyDate(date));
    case 'Mm dd, yyyy':
      return getDateLongMonth(date as Date);
    case 'Mm dd, yyyy hh:mm:ss':
      return `${getDateLongMonth(date as Date)} ${getTimeGB(
        getFullyDate(date)
      )}`;
    case 'dd/mm/yyyy hh:mm:ss':
    default:
      return `${getDateEN(getFullyDate(date))} ${getTimeGB(
        getFullyDate(date)
      )}`;
  }
};

export const dateToUTC = (
  date: number | Date,
  isGMTLabel?: boolean
): string => {
  const utcDate = getFullyDate(date).toUTCString();
  return `${isGMTLabel ? utcDate : utcDate.replace('GMT', '')}`;
};

const getFullyDate = (date: number | Date): Date =>
  new Date(typeof date === 'number' ? date * thousand : date);

const getDateEN = (date: Date): string => date.toLocaleDateString('en-EN');
const getDateBY = (date: Date): string => date.toLocaleDateString('be-BY');
const getDateLongMonth = (date: Date): string => {
  const monthAndDay = date.toLocaleDateString('en-EN', {
    month: 'long',
    day: '2-digit',
  });
  return `${monthAndDay}, ${date.getFullYear()}`;
};
const getTimeGB = (date: Date): string => date.toLocaleTimeString('en-GB');

const getTimeGBSecondsFree = (date: Date): string =>
  date.toLocaleTimeString('en-GB', {
    hour: 'numeric',
    minute: 'numeric',
  });

export const addZeroToDate = (val: number) => (val < ten ? `0${val}` : val);
